import styled from 'styled-components'
import NoLayersAlert from '../../components/no-layers-alert'
import { Grid, Label as LabelComponent } from '../style'

export const Label = styled(LabelComponent)`
    grid-column: span 8;
`

export const Layers = styled(Grid)`
    grid-row-gap: 10px;
`

export const LayersList = styled.div`
    grid-column: span 8;
`

export const NoLayers = styled(NoLayersAlert)`
    grid-column: span 8;
`
